var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllProjectsMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cases_black_24dp_2_",
    "data-name": "cases_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7874",
    "data-name": "Group 7874"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    "data-name": "Rectangle 1723",
    width: 26,
    height: 26,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7876",
    "data-name": "Group 7876",
    transform: "translate(1.065 1.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7875",
    "data-name": "Group 7875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M3.129,9H1V20.71A2.122,2.122,0,0,0,3.129,22.84h18.1V20.71H3.129Z",
    transform: "translate(-1 -0.483)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M18.84,5.258V3.129A2.135,2.135,0,0,0,16.71,1H12.452a2.135,2.135,0,0,0-2.129,2.129V5.258H5v11.71A2.135,2.135,0,0,0,7.129,19.1h14.9a2.135,2.135,0,0,0,2.129-2.129V5.258ZM12.452,3.129H16.71V5.258H12.452Zm9.581,13.84H7.129V7.387h14.9Z",
    transform: "translate(-0.742 -1)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjectsMenu);
export default __webpack_public_path__ + "static/media/all_projects_menu.d63ed86dff03ee55d2377f40cbb45104.svg";
export { ForwardRef as ReactComponent };